module.exports = __webpack_public_path__ + "img/main.dbdf3813.png";